var map = {
	"./en-us.js": "./src/locales/lang/en-us.js",
	"./module/en-us/common.js": "./src/locales/lang/module/en-us/common.js",
	"./module/en-us/components/chat.js": "./src/locales/lang/module/en-us/components/chat.js",
	"./module/en-us/components/dropdown-search.js": "./src/locales/lang/module/en-us/components/dropdown-search.js",
	"./module/en-us/components/reference_image_picker.js": "./src/locales/lang/module/en-us/components/reference_image_picker.js",
	"./module/en-us/components/upload.js": "./src/locales/lang/module/en-us/components/upload.js",
	"./module/en-us/components/vue-markdown.js": "./src/locales/lang/module/en-us/components/vue-markdown.js",
	"./module/en-us/components/vueblocknote.js": "./src/locales/lang/module/en-us/components/vueblocknote.js",
	"./module/en-us/layout/layout.js": "./src/locales/lang/module/en-us/layout/layout.js",
	"./module/en-us/mermaid.js": "./src/locales/lang/module/en-us/mermaid.js",
	"./module/en-us/notification.js": "./src/locales/lang/module/en-us/notification.js",
	"./module/en-us/time.js": "./src/locales/lang/module/en-us/time.js",
	"./module/en-us/utils/utils.js": "./src/locales/lang/module/en-us/utils/utils.js",
	"./module/en-us/views/404.js": "./src/locales/lang/module/en-us/views/404.js",
	"./module/en-us/views/account_center.js": "./src/locales/lang/module/en-us/views/account_center.js",
	"./module/en-us/views/agent.js": "./src/locales/lang/module/en-us/views/agent.js",
	"./module/en-us/views/attachment.js": "./src/locales/lang/module/en-us/views/attachment.js",
	"./module/en-us/views/chat.js": "./src/locales/lang/module/en-us/views/chat.js",
	"./module/en-us/views/dashboard.js": "./src/locales/lang/module/en-us/views/dashboard.js",
	"./module/en-us/views/domain.js": "./src/locales/lang/module/en-us/views/domain.js",
	"./module/en-us/views/home.js": "./src/locales/lang/module/en-us/views/home.js",
	"./module/en-us/views/image_generation.js": "./src/locales/lang/module/en-us/views/image_generation.js",
	"./module/en-us/views/invitation.js": "./src/locales/lang/module/en-us/views/invitation.js",
	"./module/en-us/views/invite.js": "./src/locales/lang/module/en-us/views/invite.js",
	"./module/en-us/views/knowledge.js": "./src/locales/lang/module/en-us/views/knowledge.js",
	"./module/en-us/views/legal.js": "./src/locales/lang/module/en-us/views/legal.js",
	"./module/en-us/views/login.js": "./src/locales/lang/module/en-us/views/login.js",
	"./module/en-us/views/org_admin.js": "./src/locales/lang/module/en-us/views/org_admin.js",
	"./module/en-us/views/user_center.js": "./src/locales/lang/module/en-us/views/user_center.js",
	"./module/en-us/views/video_generation.js": "./src/locales/lang/module/en-us/views/video_generation.js",
	"./module/zh-cn/common.js": "./src/locales/lang/module/zh-cn/common.js",
	"./module/zh-cn/components/chat.js": "./src/locales/lang/module/zh-cn/components/chat.js",
	"./module/zh-cn/components/dropdown-search.js": "./src/locales/lang/module/zh-cn/components/dropdown-search.js",
	"./module/zh-cn/components/reference_image_picker.js": "./src/locales/lang/module/zh-cn/components/reference_image_picker.js",
	"./module/zh-cn/components/upload.js": "./src/locales/lang/module/zh-cn/components/upload.js",
	"./module/zh-cn/components/vue-markdown.js": "./src/locales/lang/module/zh-cn/components/vue-markdown.js",
	"./module/zh-cn/components/vueblocknote.js": "./src/locales/lang/module/zh-cn/components/vueblocknote.js",
	"./module/zh-cn/layout/layout.js": "./src/locales/lang/module/zh-cn/layout/layout.js",
	"./module/zh-cn/mermaid.js": "./src/locales/lang/module/zh-cn/mermaid.js",
	"./module/zh-cn/notification.js": "./src/locales/lang/module/zh-cn/notification.js",
	"./module/zh-cn/time.js": "./src/locales/lang/module/zh-cn/time.js",
	"./module/zh-cn/utils/utils.js": "./src/locales/lang/module/zh-cn/utils/utils.js",
	"./module/zh-cn/views/404.js": "./src/locales/lang/module/zh-cn/views/404.js",
	"./module/zh-cn/views/account_center.js": "./src/locales/lang/module/zh-cn/views/account_center.js",
	"./module/zh-cn/views/agent.js": "./src/locales/lang/module/zh-cn/views/agent.js",
	"./module/zh-cn/views/attachment.js": "./src/locales/lang/module/zh-cn/views/attachment.js",
	"./module/zh-cn/views/chat.js": "./src/locales/lang/module/zh-cn/views/chat.js",
	"./module/zh-cn/views/dashboard.js": "./src/locales/lang/module/zh-cn/views/dashboard.js",
	"./module/zh-cn/views/domain.js": "./src/locales/lang/module/zh-cn/views/domain.js",
	"./module/zh-cn/views/home.js": "./src/locales/lang/module/zh-cn/views/home.js",
	"./module/zh-cn/views/image_generation.js": "./src/locales/lang/module/zh-cn/views/image_generation.js",
	"./module/zh-cn/views/invitation.js": "./src/locales/lang/module/zh-cn/views/invitation.js",
	"./module/zh-cn/views/invite.js": "./src/locales/lang/module/zh-cn/views/invite.js",
	"./module/zh-cn/views/knowledge.js": "./src/locales/lang/module/zh-cn/views/knowledge.js",
	"./module/zh-cn/views/legal.js": "./src/locales/lang/module/zh-cn/views/legal.js",
	"./module/zh-cn/views/login.js": "./src/locales/lang/module/zh-cn/views/login.js",
	"./module/zh-cn/views/org_admin.js": "./src/locales/lang/module/zh-cn/views/org_admin.js",
	"./module/zh-cn/views/user_center.js": "./src/locales/lang/module/zh-cn/views/user_center.js",
	"./module/zh-cn/views/video_generation.js": "./src/locales/lang/module/zh-cn/views/video_generation.js",
	"./module/zh-tw/common.js": "./src/locales/lang/module/zh-tw/common.js",
	"./module/zh-tw/components/chat.js": "./src/locales/lang/module/zh-tw/components/chat.js",
	"./module/zh-tw/components/dropdown-search.js": "./src/locales/lang/module/zh-tw/components/dropdown-search.js",
	"./module/zh-tw/components/reference_image_picker.js": "./src/locales/lang/module/zh-tw/components/reference_image_picker.js",
	"./module/zh-tw/components/upload.js": "./src/locales/lang/module/zh-tw/components/upload.js",
	"./module/zh-tw/components/vue-markdown.js": "./src/locales/lang/module/zh-tw/components/vue-markdown.js",
	"./module/zh-tw/components/vueblocknote.js": "./src/locales/lang/module/zh-tw/components/vueblocknote.js",
	"./module/zh-tw/layout/layout.js": "./src/locales/lang/module/zh-tw/layout/layout.js",
	"./module/zh-tw/mermaid.js": "./src/locales/lang/module/zh-tw/mermaid.js",
	"./module/zh-tw/notification.js": "./src/locales/lang/module/zh-tw/notification.js",
	"./module/zh-tw/time.js": "./src/locales/lang/module/zh-tw/time.js",
	"./module/zh-tw/utils/utils.js": "./src/locales/lang/module/zh-tw/utils/utils.js",
	"./module/zh-tw/views/404.js": "./src/locales/lang/module/zh-tw/views/404.js",
	"./module/zh-tw/views/account_center.js": "./src/locales/lang/module/zh-tw/views/account_center.js",
	"./module/zh-tw/views/agent.js": "./src/locales/lang/module/zh-tw/views/agent.js",
	"./module/zh-tw/views/attachment.js": "./src/locales/lang/module/zh-tw/views/attachment.js",
	"./module/zh-tw/views/chat.js": "./src/locales/lang/module/zh-tw/views/chat.js",
	"./module/zh-tw/views/dashboard.js": "./src/locales/lang/module/zh-tw/views/dashboard.js",
	"./module/zh-tw/views/domain.js": "./src/locales/lang/module/zh-tw/views/domain.js",
	"./module/zh-tw/views/home.js": "./src/locales/lang/module/zh-tw/views/home.js",
	"./module/zh-tw/views/image_generation.js": "./src/locales/lang/module/zh-tw/views/image_generation.js",
	"./module/zh-tw/views/invitation.js": "./src/locales/lang/module/zh-tw/views/invitation.js",
	"./module/zh-tw/views/invite.js": "./src/locales/lang/module/zh-tw/views/invite.js",
	"./module/zh-tw/views/knowledge.js": "./src/locales/lang/module/zh-tw/views/knowledge.js",
	"./module/zh-tw/views/legal.js": "./src/locales/lang/module/zh-tw/views/legal.js",
	"./module/zh-tw/views/login.js": "./src/locales/lang/module/zh-tw/views/login.js",
	"./module/zh-tw/views/org_admin.js": "./src/locales/lang/module/zh-tw/views/org_admin.js",
	"./module/zh-tw/views/user_center.js": "./src/locales/lang/module/zh-tw/views/user_center.js",
	"./module/zh-tw/views/video_generation.js": "./src/locales/lang/module/zh-tw/views/video_generation.js",
	"./zh-cn.js": "./src/locales/lang/zh-cn.js",
	"./zh-tw.js": "./src/locales/lang/zh-tw.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/locales/lang sync recursive [A-Za-z0-9-_,\\s]+\\.js$i";